
const SingleServiceFlip = (props) => {
	return(
        <div className={props.itemClass}>
            <div className="flip-box-wrap">
                <div className="front-part">
                    <div className="front-content-part">
                        <div className="front-icon-part">
                            <div className="icon-part">
                                <img
                                    src={props.serviceImage}
                                    alt={props.Title}
                                />
                            </div>
                        </div>
                        <div className="front-title-part">
                            <h3 className="title">{props.Title}</h3>
                        </div>
                        <div className="front-desc-part">
                            <p>
                                {props.TextDesc}
                            </p>
                        </div>
                    </div>
                </div>
                <div className="back-front">
                    <div className="back-front-content">
                        <div className="back-title-part">
                            <h3 className="back-title">
                                <a href={props.serviceURL} target="_blank">
                                    {props.Title}
                                </a>
                            </h3>
                        </div>
                        <div className="back-desc-part">
                            <p className="back-desc">
                                {props.TextDesc}
                            </p>
                        </div>
                        <div className="back-btn-part">
                            <a href={props.serviceURL} className={props.ButtonClass} target="_blank"> {props.ButtonText}</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
	)
}

export default SingleServiceFlip